// extracted by mini-css-extract-plugin
export default {"page":"t3-z","cartModal":"u3-z","checkout":"v3-z","placeholder":"w3-z","account":"x3-z"};